import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://gxleng.com";
const SITE_NAME = "GXL Engineering & Trading Sdn Bhd";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

const SEO = ({
  title,
  description,
  image,
  url,
  type = "website",
  article = null,
  noSuffix = false,
  structuredData = null,
}) => {
  const fullTitle = title
    ? noSuffix ? title : `${title} | ${SITE_NAME}`
    : `${SITE_NAME} - Engineering Precision. Empowering Possibility`;

  const metaDescription =
    description ||
    "GXL Engineering - Precision engineering specialists in Malaysia. CNC machining, EDM, custom tooling & jigs. ISO 9001 certified.";

  const canonicalUrl = url ? `${SITE_URL}${url}` : SITE_URL;
  const ogImage = image || DEFAULT_IMAGE;
  const structuredDataItems = Array.isArray(structuredData)
    ? structuredData
    : structuredData
      ? [structuredData]
      : [];
  const serializeStructuredData = (item) =>
    JSON.stringify(item).replace(/</g, "\\u003c");

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph Tags */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:alt" content={title || SITE_NAME} />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={ogImage} />

      {/* Article-specific tags */}
      {type === "article" && article && (
        <>
          {article.publishedTime && (
            <meta property="article:published_time" content={article.publishedTime} />
          )}
          {article.modifiedTime && (
            <meta property="article:modified_time" content={article.modifiedTime} />
          )}
        </>
      )}

      {structuredDataItems.map((item, index) => (
        <script
          key={`structured-data-${index}`}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: serializeStructuredData(item) }}
        />
      ))}
    </Helmet>
  );
};

export default SEO;
